import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Apple, Beef, Carrot, Cookie, GlassWater, Milk, Cigarette, Snowflake, Cake, Sparkles, Package, Tag, ShoppingBasket, Wheat, Droplet } from 'lucide-react';
import axios from 'axios';

const API = window.location.origin + '/api';

// Map common category slugs → icon + color gradient
const CATEGORY_VISUALS = {
  vegetables: { Icon: Carrot, from: '#16A34A', to: '#22C55E' },
  fruits: { Icon: Apple, from: '#DC2626', to: '#F87171' },
  meats: { Icon: Beef, from: '#7F1D1D', to: '#B91C1C' },
  dairy: { Icon: Milk, from: '#0EA5E9', to: '#38BDF8' },
  drinks: { Icon: GlassWater, from: '#0369A1', to: '#0EA5E9' },
  snacks: { Icon: Cookie, from: '#D97706', to: '#F59E0B' },
  frozen: { Icon: Snowflake, from: '#0891B2', to: '#67E8F9' },
  baking: { Icon: Cake, from: '#BE185D', to: '#EC4899' },
  grains: { Icon: Wheat, from: '#92400E', to: '#D97706' },
  condiments: { Icon: Droplet, from: '#7C2D12', to: '#EA580C' },
  household: { Icon: Sparkles, from: '#6D28D9', to: '#A78BFA' },
  'personal-care': { Icon: Sparkles, from: '#9333EA', to: '#C084FC' },
  'paper-and-wrap': { Icon: Package, from: '#475569', to: '#94A3B8' },
  'canned-goods': { Icon: Package, from: '#52525B', to: '#A1A1AA' },
  tobacco: { Icon: Cigarette, from: '#525252', to: '#737373' },
  discounts: { Icon: Tag, from: '#0A1F44', to: '#1E40AF' },
};

const FALLBACK = { Icon: ShoppingBasket, from: '#0A1F44', to: '#1E40AF' };
const MAX_TILES = 8;

export default function CategoryGrid() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(`${API}/categories`)
      .then(r => setCategories(r.data || []))
      .catch(err => console.error('Failed to load categories:', err.message));
  }, []);

  if (categories.length === 0) return null;

  // Always include "discounts" at the end if present + sort the rest by order then take top MAX_TILES-1
  const discounts = categories.find(c => c.slug === 'discounts');
  const rest = categories.filter(c => c.slug !== 'discounts').sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
  const finalList = discounts ? [...rest.slice(0, MAX_TILES - 1), discounts] : rest.slice(0, MAX_TILES);

  return (
    <div className="home-section" data-testid="category-grid-section">
      <div className="home-section-header">
        <h2 className="section-heading" style={{ margin: 0 }}>Shop by Category</h2>
      </div>
      <div className="category-tile-grid" data-testid="category-tile-grid">
        {finalList.map(cat => {
          const v = CATEGORY_VISUALS[cat.slug] || FALLBACK;
          const { Icon } = v;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="category-tile"
              data-testid={`home-cat-${cat.slug}`}
              style={{ background: `linear-gradient(135deg, ${v.from}, ${v.to})` }}
            >
              <div className="category-tile-icon">
                <Icon size={28} />
              </div>
              <div className="category-tile-label">{cat.name}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
